import { store } from '../../../../resources/frontend/js/store/index';

/**
 * Get parameters from URL
 * @returns {Object}
 */
export const getParameters = () => {
    let parametersString = window.location.search.substring(1).replace(/&$/, '');
    const parametersList = parametersString.split('&');
    let parameters = {};

    parametersList.forEach(parameter => {
        if(parameter !== '') {
            const data = parameter.split('=');
            const key = data[0];
            const value = data[1];
            parameters[key] = value;
        }
    });

    return parameters;
};

/**
 * Update a parameter in the URL
 * @param {string} parameter
 * @param {string} value
 */
export const updateParameter = (parameter, value) => {
    const storeQuiz = store.state.quiz;

    if(storeQuiz.browserBackButton === true) {
        let parameters = getParameters();
        parameters[parameter] = value;
        let parametersString = '';

        for (const item in parameters) {
            const string = `${item}=${parameters[item]}&`;
            parametersString += string;
        }

        parametersString = parametersString.replace(/&$/, '');

        const location = window.location.protocol + '//' + window.location.host + window.location.pathname + '?' + parametersString;
        window.history.pushState({path: location}, '', location);
    }
};

export const updateParameters = (newParameters) => {
    const storeQuiz = store.state.quiz;

    if(storeQuiz.browserBackButton === true) {
        let parameters = getParameters();

        for(const [key, value] of Object.entries(newParameters)) {
            parameters[key] = value;
        }

        let parametersString = '';

        for (const item in parameters) {
            const string = `${item}=${parameters[item]}&`;
            parametersString += string;
        }

        parametersString = parametersString.replace(/&$/, '');

        const location = window.location.protocol + '//' + window.location.host + window.location.pathname + '?' + parametersString;
        window.history.pushState({path: location}, '', location);
    }
};
